import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from "../../Utils/toastContext";

import moment from 'moment';
import Select from 'react-select';
import { 
  get_user_accounts, 
  get_user_info, 
  get_customer_cash_ac,
  get_customer_securities,
  get_all_countries,
  get_beneficiary_list,
  trans_request_cancel,
  currency_list, 
  get_active_trans_req_step,
  get_customer_account,
  app_bank_accounts
} from '../../services/common';
import Toast from '../../Components/Toast/Toast';
import { XMarkIcon, DocumentTextIcon } from '@heroicons/react/24/solid';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BeneficiaryModal from '../Customer/Beneficiary';

const Debit = () => {
  const navigate = useNavigate();
  const { showToast } = useToast(); 
  
  const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au'
  // Add token state
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [activeTab, setActiveTab] = useState('account');
  const [finalStep, setFinalStep] = useState(5);
  const [userInfo, setUserInfo] = useState({});
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [cashAccounts, setCashAccounts] = useState([]);
  const [securitiesAccounts, setSecuritiesAccounts] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState('');
  const [banks, setBanks] = useState([]);
 const [property, setPropertyAc] = useState([]);
 const [fum,setFum] = useState([]);
 const [myInvestment, setmyInvestment] = useState([]);
 const [custodian, setCustodian] = useState([]);
 const [commodities, setCommodities] = useState([]);
 const [crypto, setCrypto] = useState([]);
  const [reqDetails, setReqDetails] = useState({});
  const [records, setRecords] = useState({});
  // Modify initializeData to accept token parameter
  const [isDataInitialized, setIsDataInitialized] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    // Account Info (existing)
    ac_id: '',
    cashac_id: '',
    ac_ref_code: '',
    payment_reason: '',
    
    // Beneficiary Info
    beneficiary_type: '',
    beneficiary_id: '',
    bank_id: '',
    beneficiary_user_type: '',
    beneficiary_name: '',
    beneficiary_company_reg_no: '',
    beneficiary_nationality: '',
    beneficiary_reg_country: '',
    beneficiary_structure: '',
    beneficiary_passport_no: '',
    beneficiary_passport_expiry: '',
    beneficiary_passport_country: '',
    beneficiary_dob: '',
    beneficiary_home_address: '',
    beneficiary_email_id: '',
    beneficiary_phone_no: '',
    beneficiary_trust: '',
    beneficiary_usa_citizen: '',
    beneficiary_tax_resident_usa: '',
    beneficiary_social_security_no: '',
    beneficiary_tax_id: '',
    
    // Payment Details
    payment_amount: '',
    payment_currency: '',
    payment_type: '',
    bank_name: '',
    bank_address: '',
    bank_swift_code: '',
    bank_ac_name: '',
    bank_ac_no: '',
    beneficiary_ref_no: '',
    your_ref_no: '',
    payment_transmission_type: '',
    bank_officer_name: '',
    bank_officer_phone_no: '',
    bank_officer_email_address: '',
    
    // E-Signature
    esign_name: '',
    esign_email_id: '',
    esign_phone_no: '',
    esign_dob: '',
    
    // Upload Proof
    is_colour_passport: '',
    colour_passport_path: '',
    colour_passport_pbar: 0,
    colour_passport_pbar_p: '0%',
    colour_passport_pdiv: false,
    
    is_residence_proof: '',
    residence_proof_path: '',
    residence_proof_pbar: 0,
    residence_proof_pbar_p: '0%',
    residence_proof_pdiv: false,
    
    is_contract_proof: '',
    contract_proof_path: '',
    contract_proof_pbar: 0,
    contract_proof_pbar_p: '0%',
    contract_proof_pdiv: false,
    
    is_incorporation_certi: '',
    incorporation_certi_path: '',
    incorporation_certi_pbar: 0,
    incorporation_certi_pbar_p: '0%',
    incorporation_certi_pdiv: false,
    
    is_driver_license: '',
    driver_license_path: '',
    driver_license_pbar: 0,
    driver_license_pbar_p: '0%',
    driver_license_pdiv: false,
  });

  // File states
  const [files, setFiles] = useState({
    trans_proof: null,
    trust_deed: null,
    colour_passport: null,
    residence_proof: null,
    contract_proof: null,
    incorporation_certi: null,
    driver_license: null
  });

  const [fileNames, setFileNames] = useState({
    trans_proof: '',
    trust_deed: '',
    colour_passport: 'Select Passport',
    residence_proof: 'Select Residence Proof',
    contract_proof: 'Select Contract Proof',
    incorporation_certi: 'Select Certificate',
    driver_license: 'Select Driving License'
  });

  // Add state for place search
  const [placeSuggestion, setPlaceSuggestion] = useState(false);
  const [placeList, setPlaceList] = useState([]);
  const [timer, setTimer] = useState(null);

  // Add state for tracking completed steps
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isStepSubmitted, setIsStepSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Add this after the state declarations
  const steps = [
    { id: 1, name: 'Account Information', key: 'account' },
    { id: 2, name: 'Beneficiary Information', key: 'beneficiary' },
    { id: 3, name: 'Payment Details', key: 'payment_details' },
    { id: 4, name: 'E-Signature', key: 'e_signature' },
    { id: 5, name: 'Upload Proof', key: 'upload' }
  ];

  const toastRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem('systemToken') || '';
    if (!token) {
      navigate('/sign-in');
      return;
    }

    try {
      const parsedToken = token;
      setToken(parsedToken); // Set the token in state
      document.title = "Account Debit Form || Caprock Merchant Platform";
      localStorage.setItem('active_page', 'account_form');
      
      initializeData(parsedToken); // Pass token to initializeData
    } catch (error) {
      console.error('Error parsing token:', error);
      navigate('/sign-in');
    }
  }, []);

  // Monitor state updates and trigger getActiveRequest
  useEffect(() => {
    const allStates = {
      cashAccounts,
      securitiesAccounts,
      property,
      myInvestment,
      custodian,
      commodities,
      crypto
    };
    
    // console.log("State Updates:", allStates);
    
    // Check if all states have been initialized and have data
    const hasData = Object.values(allStates).every(state => Array.isArray(state));
    const hasAnyData = Object.values(allStates).some(state => state.length > 0);
    
    // console.log("All states initialized:", hasData);
    // console.log("Has any data:", hasAnyData);
    
    // Only proceed if we have initialized data and initialization is complete
    if (hasData && isDataInitialized) {
      // console.log("All states are ready, calling getActiveRequest");
      getActiveRequest(token);
    }
  }, [cashAccounts, securitiesAccounts, property, myInvestment, custodian, commodities, crypto, isDataInitialized, token]);

  // Handle step management based on completedSteps
  useEffect(() => {
    // If we have completed steps, set to the last completed step + 1
    // unless we're already on a valid step
    if (completedSteps.length > 0) {
      const lastCompletedStep = Math.max(...completedSteps);
      const nextStep = lastCompletedStep + 1;
      
      // Only update if current step is invalid or not set
      if (!currentStep || (!completedSteps.includes(currentStep) && currentStep > nextStep)) {
        // console.log("Setting step to:", nextStep);
        setCurrentStep(nextStep);
        const stepInfo = steps.find(s => s.id === nextStep);
        if (stepInfo) {
          setActiveTab(stepInfo.key);
        }
      }
    } else {
      // No completed steps, start from step 1
      setCurrentStep(1);
      setActiveTab(steps[0]?.key || 'account');
    }
  }, [completedSteps, currentStep, steps]);

  // Add the missing fetch functions
  const fetchCashAccounts = async () => {
    try {
        const token = localStorage.getItem('systemToken') || '';
   
      const response = await get_customer_cash_ac(token, 'fum,securities');
      if (response?.success === 200) { // Changed from response?.data?.success
        // console.log("Fetched cash accounts:", response.cash_accounts);
        // Filter linked accounts
        const filteredAccounts = response.cash_accounts.filter(
          acc => acc.is_linked === '1' || acc.is_linked === 1
        );
        setCashAccounts(filteredAccounts);
      }
    } catch (error) {
      console.error('Error fetching cash accounts:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load cash accounts');
      }
    }
  };

  const fetchSecuritiesAccounts = async (userToken) => {
    try {
      const response = await get_customer_securities(userToken);
      if (response?.success === 200) {
        // console.log("Fetched securities accounts:", response.secuirty_accounts);
        setSecuritiesAccounts(response.secuirty_accounts || []);
      }
    } catch (error) {
      console.error('Error fetching securities accounts:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load securities accounts');
      }
    }
  };

  const cancelRequest = async() =>{
    // Show confirmation dialog
    const confirmed = window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.');
    
    if (!confirmed) {
      return; // User clicked "No", so exit without canceling
    }

    try {
      const response = await trans_request_cancel(token, '1');
      if (response?.success === 200) {
        showToast(response.message, "success");
        navigate('/');
      }
    } catch (error) {
      console.error('Error canceling request:', error);
    }
  }

  const fetchCountries = async (userToken) => {
    try {
      const response = await get_all_countries(userToken);
      if (response?.success === 1) {
        // console.log(response.data.countries);
        setCountries(response.data.countries || []);
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const fetchCurrencies = async (userToken) => {
    try {
      const response = await currency_list(userToken);
      if (response?.currencies) {
        setCurrencies(response.currencies || []);
      }
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };

  const fetchBanks = async (userToken) => {
    try {
      // console.log("getching banks");
      const response = await app_bank_accounts(userToken); // Assuming get_user_accounts can fetch banks
      if (response?.bank_accounts) {
        // console.log("Bank in debit js")
        setBanks(response?.bank_accounts || []); // Assuming response.accounts contains bank details
      }
    } catch (error) {
      console.error('Error fetching banks:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load banks');
      }
    }
  };

  const fetchBeneficiaries = async (userToken) => {
    try {
      const response = await get_beneficiary_list(userToken);
      if (response?.beneficiary) {
        setBeneficiaries(response.beneficiary || []);

        setFormData(prev => ({
          ...prev,
          beneficiary_name: response.beneficiary.beneficiary_name,
          beneficiary_company_reg_no: response.beneficiary.beneficiary_company_reg_no,
          beneficiary_nationality: response.beneficiary.beneficiary_nationality,
          beneficiary_reg_country: response.beneficiary.beneficiary_reg_country,
          beneficiary_structure: response.beneficiary.beneficiary_structure,
          beneficiary_passport_no: response.beneficiary.beneficiary_passport_no,
          beneficiary_passport_expiry: response.beneficiary.beneficiary_passport_expiry,
          beneficiary_passport_country: response.beneficiary.beneficiary_passport_country,
          beneficiary_dob: response.beneficiary.beneficiary_dob,
          beneficiary_home_address: response.beneficiary.beneficiary_home_address,
          beneficiary_email_id: response.beneficiary.beneficiary_email_id,
          beneficiary_phone_no: response.beneficiary.beneficiary_phone_no,
          beneficiary_trust: response.beneficiary.beneficiary_trust,
          beneficiary_usa_citizen: response.beneficiary.beneficiary_usa_citizen,
          beneficiary_tax_resident_usa: response.beneficiary.beneficiary_tax_resident_usa,
          beneficiary_social_security_no: response.beneficiary.beneficiary_social_security_no,
          beneficiary_tax_id: response.beneficiary.beneficiary_tax_id,
        }));
      }
    } catch (error) {
      console.error('Error fetching beneficiaries:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load beneficiaries');
      }
    }
  };
 

  const initializeData = async (userToken) => {
    try {
      setLoading(true);
      
      // Fetch all account data first
      const [
        cashResponse,
        securitiesResponse,
        propertyResponse,
        fumResponse,
        investmentResponse,
        custodianResponse,
        commoditiesResponse,
        cryptoResponse
      ] = await Promise.all([
        get_customer_cash_ac(userToken, 'fum,securities'),
        get_customer_securities(userToken),
        get_customer_account("property", userToken),
        get_customer_account("fum", userToken),
        get_customer_account("my-investment", userToken),
        get_customer_account("custodian", userToken),
        get_customer_account("commodities", userToken),
        get_customer_account("crypto", userToken)
      ]);

      // Update all states at once
      if (cashResponse?.success === 200) {
        setCashAccounts(cashResponse.cash_accounts || []);
      }
      if (securitiesResponse?.success === 200) {
        setSecuritiesAccounts(securitiesResponse.secuirty_accounts || []);
      }
      if (propertyResponse?.success === 200) {
        setPropertyAc(propertyResponse.ac_data?.subaccounts || []);
      }
      if (fumResponse?.success === 200) {
        setFum(fumResponse.ac_data?.subaccounts || []);
      }
      if (investmentResponse?.success === 200) {
        setmyInvestment(investmentResponse.ac_data?.subaccounts || []);
      }
      if (custodianResponse?.success === 200) {
        setCustodian(custodianResponse.ac_data?.subaccounts || []);
      }
      if (commoditiesResponse?.success === 200) {
        setCommodities(commoditiesResponse.ac_data?.subaccounts || []);
      }
      if (cryptoResponse?.success === 200) {
        setCrypto(cryptoResponse.ac_data?.subaccounts || []);
      }

      // Fetch other necessary data
      await Promise.all([
        fetchUserInfo(userToken),
        fetchUserAccounts(userToken),
        fetchCountries(userToken),
        fetchCurrencies(userToken),
        fetchBanks(userToken),
        fetchBeneficiaries(userToken)
      ]);

      // Set initialization flag
      setIsDataInitialized(true);

    } catch (error) {
      console.error('Error initializing data:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load initial data');
      }
    } finally {
      setLoading(false);
    }
  };

  const map_ac = {
    1: "cash",
    3: "securities",
    2: "property",
    4: "my-investment",
    5: "custodian",
    6: "commodities",
    7: "crypto"
  }

  // Add console logs to diagnose the issue
  const handleAccountTypeChange = (e) => {
    const value = e.target.value;
    // console.log('Selected Account Type:', value);
    setSelectedAccountType(value);
    setFormData(prev => ({
      ...prev,
      ac_id: value,
      cashac_id: '',
      ac_ref_code: ''
    }));

    // Determine the subaccounts based on the selected account type
    const accountType = map_ac[value];
    // console.log('Account Type:', accountType);
    let subAccounts = [];
    switch (accountType) {
      case 'cash':
        subAccounts = cashAccounts;
        break;
      case 'property':
        subAccounts = property;
        break;
      case 'securities':
        subAccounts = securitiesAccounts;
        break;
      case 'my-investment':
        subAccounts = myInvestment;
        break;
      case 'custodian':
        subAccounts = custodian;
        break;
      case 'commodities':
        subAccounts = commodities;
        break;
      case 'crypto':
        subAccounts = crypto;
        break;
      default:
        subAccounts = [];
    }
    // console.log('SubAccounts:', subAccounts);
    setFormData(prev => ({
      ...prev,
      subAccounts
    }));
  };

 

 var userToken = localStorage.getItem('systemToken');
 const fetch_property_account = async () => {
   try {
     const response = await get_customer_account("property",userToken);
     if (response?.success === 200) {
        //  console.log("user ac")
       setPropertyAc(response.ac_data.subaccounts || []);
     }
   } catch (error) {
     console.error('Error fetching user accounts:', error);
   }
 }


 
  // Modify existing fetch functions to accept token parameter
  const fetchUserAccounts = async (userToken) => {
    try {
      const response = await get_user_accounts(userToken);
      if (response?.success === 200) {
        setCustomerAccounts(response.accounts || []);
      }
    } catch (error) {
      console.error('Error fetching accounts:', error);
    }
  };

  const fetchUserInfo = async (userToken) => {
    try {
      const response = await get_user_info(userToken);
      if (response?.success === 200) {
        const userInf = response.profile;
        userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM YYYY') : '';
        setUserInfo(userInf);
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Special handling for beneficiary type
    if (name === 'beneficiary_type') {
      setFinalStep(value === 'own' || value === 'existing' ? 4 : 5);
    }
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    const file = files[0];

    // Safari-specific file validation
    if (!file) {
      showToast('Please select a file', "error");
      return;
    }
    
    // Additional Safari file validation
    if (!file.name || file.name.trim() === '') {
      showToast('Invalid file selected. Please try again.', "error");
      e.target.value = '';
      return;
    }
    
    // Check if file is readable (Safari security check)
    if (file.size === 0) {
      showToast('Cannot read the selected file. Please try again.', "error");
      e.target.value = '';
      return;
    }
      
      // Check file size (max 10MB)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        showToast('File size must be less than 10MB. Please select a smaller file.', "error");
        e.target.value = ''; // Reset file input
        return;
      }
      
      // Check file type
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/jpg',
        'image/png'
      ];
      
      const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
      const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
      
      if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
        showToast('Invalid file type. Please select a PDF, DOC, DOCX, JPG, JPEG, or PNG file.', "error");
        e.target.value = ''; // Reset file input
        return;
      }
      
      // Check if file name is valid
      if (file.name.length > 255) {
        showToast('File name is too long. Please rename the file and try again.', "error");
        e.target.value = ''; // Reset file input
        return;
      }
      
      // Check for special characters in file name
      const invalidChars = /[<>:"/\\|?*]/;
      if (invalidChars.test(file.name)) {
        showToast('File name contains invalid characters. Please rename the file and try again.', "error");
        e.target.value = ''; // Reset file input
        return;
      }

    // Use requestAnimationFrame and setTimeout for better performance and UI responsiveness
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (file) {
          setFiles(prev => ({
            ...prev,
            [name]: file
          }));
          setFileNames(prev => ({
            ...prev,
            [name]: file.name
          }));
          
          setFormData(prev => ({
            ...prev,
            [name]: file,
            [`${name}_pdiv`]: true,
            [`${name}_pbar`]: 0,
            [`${name}_pbar_p`]: '0%'
          }));
          
          // Upload file asynchronously without blocking UI
          uploadFileAsync(name, file);
        }
      }, 50);
    });
  };

  // Separate async function for file upload to prevent UI blocking
  const uploadFileAsync = async (fieldName, file) => {
    try {
      // Safari-specific validations
      if (!file || !file.name) {
        showToast('Invalid file selected', "error");
        return;
      }
      
      if (!token) {
        showToast('Authentication error. Please refresh and try again.', "error");
        return;
      }
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('user_token', token);
      
      const response = await fetch(`${BASE_URL}/upload-file`, {
        method: 'POST',
        body: formData,
        // CORS headers for api.caprock.com.au
        headers: {
          'Accept': 'application/json',
        },
        // Cross-origin request configuration
        credentials: 'include',
        mode: 'cors'
      });
      
      const data = await response.json();
      
      if (data.success === 200) {
        setFormData(prev => ({
          ...prev,
          [`${fieldName}_path`]: data.file_path,
          [`${fieldName}_pbar_p`]: 'Upload Success'
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [`${fieldName}_pdiv`]: false,
          [`${fieldName}_pbar`]: 0,
          [`${fieldName}_pbar_p`]: 'Upload Failed'
        }));
        showToast(data.message || 'Failed to upload file', "error");
      }
    } catch (error) {
      console.error('Upload failed:', error);
      
      // Safari-specific error handling
      let errorMessage = 'Failed to upload file';
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      } else if (error.message.includes('Operation not permitted')) {
        errorMessage = 'File access denied. Please try selecting the file again.';
      } else if (error.message.includes('abort')) {
        errorMessage = 'Upload cancelled. Please try again.';
      }
      
      setFormData(prev => ({
        ...prev,
        [`${fieldName}_pdiv`]: false,
        [`${fieldName}_pbar`]: 0,
        [`${fieldName}_pbar_p`]: 'Upload Failed'
      }));
      showToast(errorMessage, "error");
    }
  };

  const handleRemoveFile = (fileType) => {
    setFiles(prev => ({
      ...prev,
      [fileType]: null
    }));
    setFileNames(prev => ({
      ...prev,
      [fileType]: ''
    }));
    setFormData(prev => ({
      ...prev,
      [fileType]: null,
      [`${fileType}_path`]: '',
      [`${fileType}_pdiv`]: false,
      [`${fileType}_pbar`]: 0,
      [`${fileType}_pbar_p`]: '0%'
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add form submission logic here
  };

  const handleAccountChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const refCode = selectedOption.getAttribute('data-ref-code');
    
    setFormData(prev => ({
      ...prev,
      cashac_id: e.target.value,
      ac_ref_code: refCode || ''
    }));
  };

  const [showBeneficiaryModal, setShowBeneficiaryModal] = useState(false);
  const [beneficiaryId, setBeneficiaryId] = useState(null);

  const viewBeneficiary = () => {
    const beneficiaryId = formData.beneficiary_id;
    if (!beneficiaryId || beneficiaryId === '') {
      showToast('Please select valid beneficiary first.', "error");
      return;
    }
    setBeneficiaryId(beneficiaryId);
    setShowBeneficiaryModal(true);
  };


  // Add validation functions for each step
  const validateStep1 = () => {
    const errors = [];
    
    if (!formData.ac_id) {
      errors.push('Please select account type');
    }
    
    if (!formData.cashac_id) {
      errors.push('Please select account to debit');
    }
    
    if (!formData.payment_reason) {
      errors.push('Please select payment reason');
    }
    
    if (!files.trans_proof) {
      errors.push('Please upload proof of transaction');
    }
    
    return errors;
  };

  const validateStep2 = () => {
    const errors = [];
    
    if (!formData.beneficiary_type) {
      errors.push('Please select beneficiary type');
    }
    
    if (formData.beneficiary_type === 'existing' && !formData.beneficiary_id) {
      errors.push('Please select beneficiary');
    }
    
    if (formData.beneficiary_type === 'own' && !formData.bank_id) {
      errors.push('Please select external bank account');
    }
    
    if (formData.beneficiary_type === 'new') {
      if (!formData.beneficiary_user_type) {
        errors.push('Please select corporate or individual');
      }
      
      if (!formData.beneficiary_name) {
        errors.push('Please enter beneficiary name');
      }
      
      if (formData.beneficiary_user_type === 'corporate') {
        if (!formData.beneficiary_company_reg_no) {
          errors.push('Please enter company registration number');
        }
        if (!formData.beneficiary_nationality) {
          errors.push('Please select country of residency');
        }
        if (!formData.beneficiary_reg_country) {
          errors.push('Please select country of registration');
        }
      }
      
      if (!formData.beneficiary_structure) {
        errors.push('Please select beneficiary structure');
      }
      
      if (!formData.beneficiary_passport_no) {
        errors.push('Please enter passport number');
      }
      
      if (!formData.beneficiary_passport_expiry) {
        errors.push('Please enter passport expiry date');
      }
      
      if (!formData.beneficiary_passport_country) {
        errors.push('Please select passport country');
      }
      
      if (!formData.beneficiary_dob) {
        errors.push('Please enter date of birth');
      }
      
      if (!formData.beneficiary_home_address) {
        errors.push('Please enter home address');
      }
      
      if (!formData.beneficiary_email_id) {
        errors.push('Please enter email address');
      }
      
      if (!formData.beneficiary_phone_no) {
        errors.push('Please enter phone number');
      }
      
      if (!formData.beneficiary_trust) {
        errors.push('Please select if beneficiary is a trust');
      }
      
      if (!formData.beneficiary_usa_citizen) {
        errors.push('Please select if beneficiary is USA citizen');
      }
      
      if (!formData.beneficiary_tax_resident_usa) {
        errors.push('Please select if beneficiary is tax resident of USA');
      }
      
      if (formData.beneficiary_trust === '1' && !files.trust_deed) {
        errors.push('Please upload trust deed');
      }
    }
    
    return errors;
  };

  const validateStep3 = () => {
    const errors = [];
    
    if (!formData.payment_amount) {
      errors.push('Please enter payment amount');
    }
    
    if (!formData.payment_currency) {
      errors.push('Please select payment currency');
    }
    
    if (!formData.payment_type) {
      errors.push('Please select payment type');
    }
    
    if (formData.beneficiary_type === 'new') {
      if (!formData.bank_name) {
        errors.push('Please enter bank name');
      }
      
      if (!formData.bank_address) {
        errors.push('Please enter bank address');
      }
      
      if (!formData.bank_swift_code) {
        errors.push('Please enter SWIFT code');
      }
      
      if (!formData.bank_ac_name) {
        errors.push('Please enter account name');
      }
      
      if (!formData.bank_ac_no) {
        errors.push('Please enter account number');
      }
      
      if (!formData.beneficiary_ref_no) {
        errors.push('Please enter beneficiary reference number');
      }
      
      if (!formData.your_ref_no) {
        errors.push('Please enter your reference number');
      }
      
      if (!formData.payment_transmission_type) {
        errors.push('Please select transmission type');
      }
    }
    
    return errors;
  };

  const validateStep4 = () => {
    const errors = [];
    
    if (!formData.esign_name) {
      errors.push('Please enter account holder name');
    }
    
    if (!formData.esign_email_id) {
      errors.push('Please enter email address');
    }
    
    if (!formData.esign_phone_no) {
      errors.push('Please enter phone number');
    }
    
    if (!formData.esign_dob) {
      errors.push('Please enter date of birth');
    }
    
    return errors;
  };

  const validateStep5 = () => {
    const errors = [];
    
    if (formData.is_driver_license !== '1') {
      if (!formData.is_colour_passport) {
        errors.push('Please select if colour passport is included');
      }
      
      if (formData.is_colour_passport === '1' && !files.colour_passport) {
        errors.push('Please upload colour passport');
      }
    }
    
    if (!formData.is_residence_proof) {
      errors.push('Please select if residence proof is included');
    }
    
    if (formData.is_residence_proof === '1' && !files.residence_proof) {
      errors.push('Please upload residence proof');
    }
    
    if (!formData.is_contract_proof) {
      errors.push('Please select if contract proof is included');
    }
    
    if (formData.is_contract_proof === '1' && !files.contract_proof) {
      errors.push('Please upload contract proof');
    }
    
    if (formData.beneficiary_user_type === 'corporate') {
      if (!formData.is_incorporation_certi) {
        errors.push('Please select if incorporation certificate is included');
      }
      
      if (formData.is_incorporation_certi === '1' && !files.incorporation_certi) {
        errors.push('Please upload incorporation certificate');
      }
    }
    
    if (formData.is_colour_passport !== '1') {
      if (!formData.is_driver_license) {
        errors.push('Please select if driver license is included');
      }
      
      if (formData.is_driver_license === '1' && !files.driver_license) {
        errors.push('Please upload driver license');
      }
    }
    
    return errors;
  };


  // Update the submit functions to mark steps as completed
  const submitForm1 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('ac_id', formData.ac_id);
    formDataToSend.append('cashac_id', formData.cashac_id);
    formDataToSend.append('payment_reason', formData.payment_reason);
    
    if (files.trans_proof) {
      formDataToSend.append('trans_proof', files.trans_proof);
    }

    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-d1`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Mark step 1 as completed
        setCompletedSteps(prev => [...prev, 1]);
        setIsStepSubmitted(true);
        setCurrentStep(2);
        setActiveTab('beneficiary');
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting form 1:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm2 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('beneficiary_type', formData.beneficiary_type);
    formDataToSend.append('bank_id', formData.bank_id);
    formDataToSend.append('beneficiary_id', formData.beneficiary_id);
    formDataToSend.append('beneficiary_name', formData.beneficiary_name);
    formDataToSend.append('beneficiary_company_reg_no', formData.beneficiary_company_reg_no);
    formDataToSend.append('beneficiary_structure', formData.beneficiary_structure);
    formDataToSend.append('beneficiary_nationality', formData.beneficiary_nationality);
    formDataToSend.append('beneficiary_reg_country', formData.beneficiary_reg_country);
    formDataToSend.append('beneficiary_user_type', formData.beneficiary_user_type);
    formDataToSend.append('beneficiary_passport_no', formData.beneficiary_passport_no);
    formDataToSend.append('beneficiary_passport_expiry', formData.beneficiary_passport_expiry);
    formDataToSend.append('beneficiary_passport_country', formData.beneficiary_passport_country);
    formDataToSend.append('beneficiary_dob', formData.beneficiary_dob);
    formDataToSend.append('beneficiary_home_address', formData.beneficiary_home_address);
    formDataToSend.append('beneficiary_email_id', formData.beneficiary_email_id);
    formDataToSend.append('beneficiary_phone_no', formData.beneficiary_phone_no);
    formDataToSend.append('beneficiary_trust', formData.beneficiary_trust);
    formDataToSend.append('beneficiary_usa_citizen', formData.beneficiary_usa_citizen);
    formDataToSend.append('beneficiary_tax_resident_usa', formData.beneficiary_tax_resident_usa);
    formDataToSend.append('beneficiary_social_security_no', formData.beneficiary_social_security_no);
    formDataToSend.append('beneficiary_tax_id', formData.beneficiary_tax_id);
    
    if (files.trust_deed) {
      formDataToSend.append('trust_deed', files.trust_deed);
    }

    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-d2`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Mark step 2 as completed
        setCompletedSteps(prev => [...prev, 2]);
        setIsStepSubmitted(true);
        setCurrentStep(3);
        setActiveTab('payment_details');
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting form 2:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm3 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('payment_amount', formData.payment_amount);
    formDataToSend.append('payment_currency', formData.payment_currency);
    formDataToSend.append('payment_type', formData.payment_type);
    formDataToSend.append('bank_name', formData.bank_name);
    formDataToSend.append('bank_address', formData.bank_address);
    formDataToSend.append('bank_swift_code', formData.bank_swift_code);
    formDataToSend.append('bank_ac_name', formData.bank_ac_name);
    formDataToSend.append('bank_ac_no', formData.bank_ac_no);
    formDataToSend.append('beneficiary_ref_no', formData.beneficiary_ref_no);
    formDataToSend.append('your_ref_no', formData.your_ref_no);
    formDataToSend.append('payment_transmission_type', formData.payment_transmission_type);
    formDataToSend.append('bank_officer_name', formData.bank_officer_name);
    formDataToSend.append('bank_officer_phone_no', formData.bank_officer_phone_no);
    formDataToSend.append('bank_officer_email_address', formData.bank_officer_email_address);

    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-d3`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Mark step 3 as completed
        setCompletedSteps(prev => [...prev, 3]);
        setIsStepSubmitted(true);
        setCurrentStep(4);
        setActiveTab('e_signature');
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting form 3:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm4 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('esign_name', formData.esign_name);
    formDataToSend.append('esign_phone_no', formData.esign_phone_no);
    formDataToSend.append('esign_dob', formData.esign_dob);
    formDataToSend.append('esign_email_id', formData.esign_email_id);

    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-d4`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Mark step 4 as completed and always proceed to step 5 (Upload Proof)
        setCompletedSteps(prev => [...prev, 4]);
        setIsStepSubmitted(true);
        setCurrentStep(5);
        setActiveTab('upload');
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting form 4:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitForm5 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('is_colour_passport', formData.is_colour_passport);
    if (formData.is_colour_passport === '1') {
      formDataToSend.append('colour_passport_path', formData.colour_passport_path);
    }
    formDataToSend.append('is_residence_proof', formData.is_residence_proof);
    if (formData.is_residence_proof === '1') {
      formDataToSend.append('residence_proof_path', formData.residence_proof_path);
    }
    formDataToSend.append('is_contract_proof', formData.is_contract_proof);
    if (formData.is_contract_proof === '1') {
      formDataToSend.append('contract_proof_path', formData.contract_proof_path);
    }
    if (formData.beneficiary_user_type === 'corporate') {
      formDataToSend.append('is_incorporation_certi', formData.is_incorporation_certi);
      if (formData.is_incorporation_certi === '1') {
        formDataToSend.append('incorporation_certi_path', formData.incorporation_certi_path);
      }
    }
    formDataToSend.append('is_driver_license', formData.is_driver_license);
    if (formData.is_driver_license === '1') {
      formDataToSend.append('driver_license_path', formData.driver_license_path);
    }

    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-d5`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Mark step 5 as completed
        setCompletedSteps(prev => [...prev, 5]);
        setIsStepSubmitted(true);
        // Final step, submit the request
        await submitFinalRequest();
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting form 5:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitFinalRequest = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('req_type', '1');

    try {
      const response = await fetch(`${BASE_URL}/trans-request-verify`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        if (toastRef.current) {
          toastRef.current.success(result.message);
        }
        // Redirect to home page
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        if (toastRef.current) {
          toastRef.current.error(result.message);
        }
      }
    } catch (error) {
      console.error('Error submitting final request:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit final request');
      }
    }
  };

  // Navigation functions
  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setActiveTab(steps[currentStep - 2]?.key || 'account');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNext = async () => {
    if (validateStep(currentStep)) {
      // Submit current step data
      // Each submit function handles its own step progression
      switch (currentStep) {
        case 1:
          await submitForm1();
          break;
        case 2:
          await submitForm2();
          break;
        case 3:
          await submitForm3();
          break;
        case 4:
          await submitForm4();
          break;
        case 5:
          await submitForm5();
          break;
      }
      // Scroll to top after submission
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      showToast(`Please fill all required fields in ${steps[currentStep - 1]?.name}`, "error");
    }
  };

  const handleSave = async () => {
    if (validateStep(currentStep)) {
      await handleStepSubmit(currentStep);
      if (toastRef.current) {
        toastRef.current.success('Form saved successfully');
      }
    } else {
      if (toastRef.current) {
        toastRef.current.error(`Please fill all required fields in ${steps[currentStep - 1]?.name}`);
      }
    }
  };

  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.')) {
      navigate('/');
    }
  };
 
  // Validation function
  const validateStep = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return validateStep1().length === 0;
      case 2:
        return validateStep2().length === 0;
      case 3:
        return validateStep3().length === 0;
      case 4:
        return validateStep4().length === 0;
      case 5:
        return validateStep5().length === 0;
      default:
        return false;
    }
  };

  // Handle step submission
  const handleStepSubmit = async (stepNumber) => {
    try {
      switch (stepNumber) {
        case 1:
          await submitForm1();
          break;
        case 2:
          await submitForm2();
          break;
        case 3:
          await submitForm3();
          break;
        case 4:
          await submitForm4();
          break;
        case 5:
          await submitForm5();
          break;
        default:
          // console.log('Unknown step number:', stepNumber);
      }
    } catch (error) {
      console.error('Error submitting step:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to submit form data');
      }
    }
  };

  // Render navigation buttons
  const renderNavigationButtons = () => (
    <div className="flex justify-end space-x-4 p-6">
      <button
        onClick={() => cancelRequest()}
        className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        disabled={isSubmitting}
      >
        Cancel
      </button>
      <button
        onClick={handlePrevious}
        className="px-6 py-2 border border-blue-500 rounded-md text-blue-500 hover:bg-blue-50"
        disabled={currentStep === 1 || isSubmitting}
      >
        Previous
      </button>
      <button
        onClick={handleNext}
        className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <>
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {currentStep === 5 ? 'Submitting...' : 'Saving...'}
          </>
        ) : (
          currentStep === 5 ? 'Finish' : 'Next'
        )}
      </button>
    </div>
  );

  const handleSubAccountChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const refCode = selectedOption.getAttribute('data-ref-code');

    setFormData(prev => ({
      ...prev,
      cashac_id: e.target.value,
      ac_ref_code: refCode || ''
    }));
  };

const renderAccountForm = () => (
  <div className="space-y-6">
    <div>
      <label className="block text-gray-700 mb-2">Select Account</label>
      <select
        name="ac_id"
        value={formData.ac_id}
        onChange={handleAccountTypeChange}
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      >
        <option value="">Select Account Type</option>
        <option value="1">Cash Account</option>
        <option value="2">Property</option>
        <option value="3">Securities</option>
        <option value="4">My Investment</option>
        <option value="5">Custodian</option>
        <option value="6">Commodities</option>
        <option value="7">Crypto</option>
      </select>
    </div>

    {formData.ac_id && (
      <div>
        <label className="block text-gray-700 mb-2">Select account to debit</label>
        <select
          name="cashac_id"
          value={formData.cashac_id}
          onChange={handleSubAccountChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">
            {formData.ac_id === '1' ? 'Select Cash Account' : 'Select Securities Account'}
          </option>
          {formData.subAccounts.map(account => (
            <option 
              key={account.subac_id} 
              value={account.subac_id}
              data-ref-code={account.subac_reference_code}
            >
              {account.subac_name}
            </option>
          ))}
        </select>
      </div>
    )}

      {/* Add Caprock Account Ref No. */}
      <div>
        <label className="block text-gray-700 mb-2">Caprock Account Ref No.</label>
        <input
          type="text"
          name="ac_ref_code"
          value={formData.ac_ref_code || ''}
          readOnly
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black bg-gray-50"
        />
      </div>

      {/* Add Reason for payment */}
      <div>
        <label className="block text-gray-700 mb-2">Reason for payment</label>
        <select
          name="payment_reason"
          value={formData.payment_reason}
          onChange={handleInputChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">Select Payment Reason</option>
          <option value="service">Service</option>
          <option value="capital_transfer">Capital Transfer</option>
          <option value="purchase">Purchase</option>
          <option value="direction_to_pay">Direction to Pay</option>
        </select>
      </div>

      {/* Add Upload proof of Transaction */}
      <div>
        <label className="block text-gray-700 mb-2">Upload proof of Transaction</label>
        <div className="relative">
          <input
            type="file"
            name="trans_proof"
            onChange={handleFileChange}
            className="hidden"
            id="trans_proof"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
          />
          <label
            htmlFor="trans_proof"
            className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
          >
            {files.trans_proof ? (
              <span className="text-gray-700">{fileNames.trans_proof}</span>
            ) : (
              <span className="text-gray-500">Choose a file or drag & drop here</span>
            )}
          </label>
        </div>
        {files.trans_proof && (
          <div className="mt-2">
            <div className="flex items-center space-x-2">
              <DocumentTextIcon className="h-5 w-5 text-gray-500" />
              <span className="text-sm text-gray-700">{fileNames.trans_proof}</span>
              <button
                type="button"
                onClick={() => handleRemoveFile('trans_proof')}
                className="text-red-500 hover:text-red-700"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
      </div>
      {renderNavigationButtons()}
  </div>
);

const renderBeneficiaryForm = () => (
  <div className="space-y-6">
    <div>
      <label className="block text-gray-700 mb-2">Beneficiary Type</label>
      <select
        name="beneficiary_type"
        value={formData.beneficiary_type}
        onChange={handleInputChange}
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      >
        <option value="">Select beneficiary type</option>
        <option value="own">Transfer to my own account</option>
        <option value="existing">Existing Beneficiary</option>
        <option value="new">New Beneficiary</option>
      </select>
    </div>

    {formData.beneficiary_type === 'existing' && (
      <div>
        <label className="block text-gray-700 mb-2">Beneficiary
              <button
                onClick={viewBeneficiary}
                className="ml-2 text-blue-600 hover:text-blue-800"
                type="button"
              >
                View beneficiary detail
              </button>

        </label>
        <select
          name="beneficiary_id"
          value={formData.beneficiary_id}
          onChange={handleInputChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">Select Beneficiary</option>
          {beneficiaries.map(beneficiary => (
            <option key={beneficiary.beneficiary_id} value={beneficiary.beneficiary_id}>
              {beneficiary.beneficiary_name}
            </option>
          ))}
        </select>
      </div>
    )}

    {formData.beneficiary_type === 'own' && (
      <div>
        <label className="block text-gray-700 mb-2">Select external bank Account</label>
        <select
          name="bank_id"
          value={formData.bank_id}
          onChange={handleInputChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">Select Bank Account</option>
          {banks.map(bank => (
            <option key={bank.bank_id} value={bank.bank_id}>
              {bank.name}
            </option>
          ))}
        </select>
      </div>
    )}

    {formData.beneficiary_type === 'new' && (
      <>
        <div>
          <label className="block text-gray-700 mb-2">Corporate or Individual</label>
          <select
            name="beneficiary_user_type"
            value={formData.beneficiary_user_type}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select type</option>
            <option value="corporate">Corporate</option>
            <option value="individual">Individual</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Name of beneficiary</label>
          <input
            type="text"
            name="beneficiary_name"
            value={formData.beneficiary_name}
            onChange={handleInputChange}
            placeholder="i.e. Jonaten"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        {formData.beneficiary_user_type === 'corporate' && (
          <div>
            <label className="block text-gray-700 mb-2">Company registration number of beneficiary</label>
            <input
              type="text"
              name="beneficiary_company_reg_no"
              value={formData.beneficiary_company_reg_no}
              onChange={handleInputChange}
              placeholder="i.e. IT56789"
              className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            />
          </div>
        )}

        <div>
          <label className="block text-gray-700 mb-2">Country of residency of Beneficiary</label>
          <select
            name="beneficiary_nationality"
            value={formData.beneficiary_nationality}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select Country</option>
            {countries.map(country => (
              <option key={country.country_id} value={country.country_id}>
                {country.country_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Country of registration of Beneficiary</label>
          <select
            name="beneficiary_reg_country"
            value={formData.beneficiary_reg_country}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select Country</option>
            {countries.map(country => (
              <option key={country.country_id} value={country.country_id}>
                {country.country_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Structure of Beneficiary</label>
          <select
            name="beneficiary_structure"
            value={formData.beneficiary_structure}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Please select</option>
            <option value="public">Public</option>
            <option value="private">Private</option>
            <option value="partnership">Partnership</option>
            <option value="individual">Individual</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Passport number of beneficiary</label>
          <input
            type="text"
            name="beneficiary_passport_no"
            value={formData.beneficiary_passport_no}
            onChange={handleInputChange}
            placeholder="i.e. L8989S446546"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Passport expiry of beneficiary</label>
          <input
            type="date"
            name="beneficiary_passport_expiry"
            value={formData.beneficiary_passport_expiry}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Country of issue of passport of beneficiary</label>
          <select
            name="beneficiary_passport_country"
            value={formData.beneficiary_passport_country}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select Country</option>
            {countries.map(country => (
              <option key={country.country_id} value={country.country_id}>
                {country.country_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Date of Birth of Beneficiary</label>
          <input
            type="date"
            name="beneficiary_dob"
            value={formData.beneficiary_dob}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Home address of Beneficiary</label>
          <input
            type="text"
            name="beneficiary_home_address"
            value={formData.beneficiary_home_address}
            onChange={handleInputChange}
            placeholder="Enter address"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Email address of Beneficiary</label>
          <input
            type="email"
            name="beneficiary_email_id"
            value={formData.beneficiary_email_id}
            onChange={handleInputChange}
            placeholder="i.e. email@address.com"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Mobile/Cell Number of Beneficiary</label>
          <input
            type="text"
            name="beneficiary_phone_no"
            value={formData.beneficiary_phone_no}
            onChange={handleInputChange}
            placeholder="i.e. +1234567890"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Is the Beneficiary a trust?</label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_trust"
                value="1"
                checked={formData.beneficiary_trust === '1'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              Yes
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_trust"
                value="0"
                checked={formData.beneficiary_trust === '0'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              No
            </label>
          </div>
        </div>

        {formData.beneficiary_trust === '1' && (
          <div>
            <label className="block text-gray-700 mb-2">Upload trust deed</label>
            <div className="relative">
              <input
                type="file"
                name="trust_deed"
                onChange={handleFileChange}
                className="hidden"
                id="trust_deed"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <label
                htmlFor="trust_deed"
                className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
              >
                <DocumentTextIcon className="w-5 h-5 mr-2" />
                {files.trust_deed ? files.trust_deed.name : 'Select Trust Deed'}
              </label>
            </div>
            {files.trust_deed && (
              <div className="mt-2">
                <span className="text-sm text-gray-600">{files.trust_deed.name}</span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile('trust_deed')}
                  className="ml-2 text-red-500 hover:text-red-700"
                >
                  <XMarkIcon className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        )}

        <div>
          <label className="block text-gray-700 mb-2">Is the Beneficiary a USA citizen?</label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_usa_citizen"
                value="1"
                checked={formData.beneficiary_usa_citizen === '1'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              Yes
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_usa_citizen"
                value="0"
                checked={formData.beneficiary_usa_citizen === '0'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              No
            </label>
          </div>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Is the Beneficiary a tax resident of the USA?</label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_tax_resident_usa"
                value="1"
                checked={formData.beneficiary_tax_resident_usa === '1'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              Yes
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="beneficiary_tax_resident_usa"
                value="0"
                checked={formData.beneficiary_tax_resident_usa === '0'}
                onChange={handleInputChange}
                className="form-radio mr-2"
              />
              No
            </label>
          </div>
        </div>

        {(formData.beneficiary_usa_citizen === '1' || formData.beneficiary_tax_resident_usa === '1') && (
          <div>
            <label className="block text-gray-700 mb-2">Social security number of Beneficiary</label>
            <input
              type="text"
              name="beneficiary_social_security_no"
              value={formData.beneficiary_social_security_no}
              onChange={handleInputChange}
              placeholder="Enter SSN"
              className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            />
          </div>
        )}

        {formData.beneficiary_tax_resident_usa === '1' && (
          <div>
            <label className="block text-gray-700 mb-2">Beneficiary Tax ID</label>
            <input
              type="text"
              name="beneficiary_tax_id"
              value={formData.beneficiary_tax_id}
              onChange={handleInputChange}
              placeholder="Enter Tax ID"
              className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            />
          </div>
        )}
      </>
    )}
    
    {renderNavigationButtons()}
  </div>
);

const renderPaymentDetailsForm = () => (
  <div className="space-y-6">
    <div>
      <label className="block text-gray-700 mb-2">Payment Amount</label>
      <input
        type="number"
        name="payment_amount"
        value={formData.payment_amount}
        onChange={handleInputChange}
        placeholder="i.e. 50000"
        step="any"
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      />
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Payment Currency</label>
      <select
        name="payment_currency"
        value={formData.payment_currency}
        onChange={handleInputChange}
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      >
        <option value="">Select currency</option>
        {currencies.map(currency => (
          <option key={currency.currency_id} value={currency.currency_id}>
            {currency.currency_symbol} {currency.currency_name}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Payment Type</label>
      <select
        name="payment_type"
        value={formData.payment_type}
        onChange={handleInputChange}
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      >
        <option value="">Select type</option>
        <option value="single">Single - One Off</option>
        <option value="recurring">Recurring</option>
      </select>
    </div>

    {formData.beneficiary_type === 'new' && (
      <>
        <div>
          <label className="block text-gray-700 mb-2">Name of receiving bank</label>
          <input
            type="text"
            name="bank_name"
            value={formData.bank_name}
            onChange={handleInputChange}
            placeholder="i.e. CITI Bank"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Address of receiving bank</label>
          <input
            type="text"
            name="bank_address"
            value={formData.bank_address}
            onChange={handleInputChange}
            placeholder="i.e. Sea Link, Sydney"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving bank SWIFT code</label>
          <input
            type="text"
            name="bank_swift_code"
            value={formData.bank_swift_code}
            onChange={handleInputChange}
            placeholder="i.e. JJDH546"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving account name</label>
          <input
            type="text"
            name="bank_ac_name"
            value={formData.bank_ac_name}
            onChange={handleInputChange}
            placeholder="i.e. Jonaten"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving bank account number</label>
          <input
            type="text"
            name="bank_ac_no"
            value={formData.bank_ac_no}
            onChange={handleInputChange}
            placeholder="i.e. 3539 000556"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Beneficiary reference number</label>
          <input
            type="text"
            name="beneficiary_ref_no"
            value={formData.beneficiary_ref_no}
            onChange={handleInputChange}
            placeholder="i.e. IG987982"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Your reference number</label>
          <input
            type="text"
            name="your_ref_no"
            value={formData.your_ref_no}
            onChange={handleInputChange}
            placeholder="i.e. IG987982"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Transmission Type</label>
          <select
            name="payment_transmission_type"
            value={formData.payment_transmission_type}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select type</option>
            <option value="swift_mt103">SWIFT MT103</option>
            <option value="rtgs">RTGS</option>
            <option value="swift_gpi">SWIFT GPI</option>
            <option value="bank_draft">Bank Draft</option>
            <option value="sblc_bg">SBLC/BG</option>
            <option value="dlc">DLC</option>
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving bank officer name</label>
          <input
            type="text"
            name="bank_officer_name"
            value={formData.bank_officer_name}
            onChange={handleInputChange}
            placeholder="i.e. Officer name"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving bank officer phone number</label>
          <input
            type="text"
            name="bank_officer_phone_no"
            value={formData.bank_officer_phone_no}
            onChange={handleInputChange}
            placeholder="i.e. +4 455545665"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Receiving bank officer email address</label>
          <input
            type="email"
            name="bank_officer_email_address"
            value={formData.bank_officer_email_address}
            onChange={handleInputChange}
            placeholder="i.e. email@address.com"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>
      </>
    )}
    
    {renderNavigationButtons()}
  </div>
);

const renderESignatureForm = () => (
  <div className="space-y-6">
    <div>
      <label className="block text-gray-700 mb-2">Name of Account Holder</label>
      <input
        type="text"
        name="esign_name"
        value={formData.esign_name}
        onChange={handleInputChange}
        placeholder="i.e. Jonaten"
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      />
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Email Address of Caprock Account Holder</label>
      <input
        type="email"
        name="esign_email_id"
        value={formData.esign_email_id}
        onChange={handleInputChange}
        placeholder="i.e. email@address.com"
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      />
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Phone Number of Caprock Account Holder</label>
      <input
        type="text"
        name="esign_phone_no"
        value={formData.esign_phone_no}
        onChange={handleInputChange}
        placeholder="i.e. 3539 000556"
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      />
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Date of Birth</label>
      <input
        type="date"
        name="esign_dob"
        value={formData.esign_dob}
        onChange={handleInputChange}
        className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
      />
    </div>
    
    {renderNavigationButtons()}
   
  </div>
);

const renderUploadProofForm = () => (
  <div className="space-y-6">
    {formData.is_driver_license !== '1' && (
      <div>
        <label className="block text-gray-700 mb-2">Certified Copy Colour Passport of Beneficiary (Included) ?</label>
        <div className="flex items-center space-x-4">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_colour_passport"
              value="1"
              checked={formData.is_colour_passport === '1'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            Yes
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_colour_passport"
              value="0"
              checked={formData.is_colour_passport === '0'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            No
          </label>
        </div>
        {formData.is_colour_passport === '1' && (
          <div className="mt-4">
            <div className="relative">
              <input
                type="file"
                name="colour_passport"
                onChange={handleFileChange}
                className="hidden"
                id="colour_passport"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <label
                htmlFor="colour_passport"
                className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
              >
                <DocumentTextIcon className="w-5 h-5 mr-2" />
                {files.colour_passport ? files.colour_passport.name : 'Select Colour Passport'}
              </label>
            </div>
            {files.colour_passport && (
              <div className="mt-2">
                <span className="text-sm text-gray-600">{files.colour_passport.name}</span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile('colour_passport')}
                  className="ml-2 text-red-500 hover:text-red-700"
                >
                  <XMarkIcon className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    )}

    <div>
      <label className="block text-gray-700 mb-2">Certified Copy Utility Bill Showing Proof of Residential Address of Beneficiary (Included?)</label>
      <div className="flex items-center space-x-4">
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="is_residence_proof"
            value="1"
            checked={formData.is_residence_proof === '1'}
            onChange={handleInputChange}
            className="form-radio mr-2"
          />
          Yes
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="is_residence_proof"
            value="0"
            checked={formData.is_residence_proof === '0'}
            onChange={handleInputChange}
            className="form-radio mr-2"
          />
          No
        </label>
      </div>
      {formData.is_residence_proof === '1' && (
        <div className="mt-4">
          <div className="relative">
            <input
              type="file"
              name="residence_proof"
              onChange={handleFileChange}
              className="hidden"
              id="residence_proof"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
            <label
              htmlFor="residence_proof"
              className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
            >
              <DocumentTextIcon className="w-5 h-5 mr-2" />
              {files.residence_proof ? files.residence_proof.name : 'Select Residence Proof'}
            </label>
          </div>
          {files.residence_proof && (
            <div className="mt-2">
              <span className="text-sm text-gray-600">{files.residence_proof.name}</span>
              <button
                type="button"
                onClick={() => handleRemoveFile('residence_proof')}
                className="ml-2 text-red-500 hover:text-red-700"
              >
                <XMarkIcon className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
      )}
    </div>

    <div>
      <label className="block text-gray-700 mb-2">Copy of contract or invoice between Caprock Account Holder and Beneficiary as proof of transaction (Included) ?</label>
      <div className="flex items-center space-x-4">
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="is_contract_proof"
            value="1"
            checked={formData.is_contract_proof === '1'}
            onChange={handleInputChange}
            className="form-radio mr-2"
          />
          Yes
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            name="is_contract_proof"
            value="0"
            checked={formData.is_contract_proof === '0'}
            onChange={handleInputChange}
            className="form-radio mr-2"
          />
          No
        </label>
      </div>
      {formData.is_contract_proof === '1' && (
        <div className="mt-4">
          <div className="relative">
            <input
              type="file"
              name="contract_proof"
              onChange={handleFileChange}
              className="hidden"
              id="contract_proof"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            />
            <label
              htmlFor="contract_proof"
              className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
            >
              <DocumentTextIcon className="w-5 h-5 mr-2" />
              {files.contract_proof ? files.contract_proof.name : 'Select Contract Proof'}
            </label>
          </div>
          {files.contract_proof && (
            <div className="mt-2">
              <span className="text-sm text-gray-600">{files.contract_proof.name}</span>
              <button
                type="button"
                onClick={() => handleRemoveFile('contract_proof')}
                className="ml-2 text-red-500 hover:text-red-700"
              >
                <XMarkIcon className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
      )}
    </div>

    {formData.beneficiary_user_type === 'corporate' && (
      <div>
        <label className="block text-gray-700 mb-2">Certified Certificate of Incorporation from Beneficiary (Included) ?</label>
        <div className="flex items-center space-x-4">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_incorporation_certi"
              value="1"
              checked={formData.is_incorporation_certi === '1'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            Yes
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_incorporation_certi"
              value="0"
              checked={formData.is_incorporation_certi === '0'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            No
          </label>
        </div>
        {formData.is_incorporation_certi === '1' && (
          <div className="mt-4">
            <div className="relative">
              <input
                type="file"
                name="incorporation_certi"
                onChange={handleFileChange}
                className="hidden"
                id="incorporation_certi"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <label
                htmlFor="incorporation_certi"
                className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
              >
                <DocumentTextIcon className="w-5 h-5 mr-2" />
                {files.incorporation_certi ? files.incorporation_certi.name : 'Select Incorporation Certificate'}
              </label>
            </div>
            {files.incorporation_certi && (
              <div className="mt-2">
                <span className="text-sm text-gray-600">{files.incorporation_certi.name}</span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile('incorporation_certi')}
                  className="ml-2 text-red-500 hover:text-red-700"
                >
                  <XMarkIcon className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    )}

    {formData.is_colour_passport !== '1' && (
      <div>
        <label className="block text-gray-700 mb-2">Certified Copy of Drivers License of Beneficiary (Included) ?</label>
        <div className="flex items-center space-x-4">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_driver_license"
              value="1"
              checked={formData.is_driver_license === '1'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            Yes
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="is_driver_license"
              value="0"
              checked={formData.is_driver_license === '0'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            No
          </label>
        </div>
        {formData.is_driver_license === '1' && (
          <div className="mt-4">
            <div className="relative">
              <input
                type="file"
                name="driver_license"
                onChange={handleFileChange}
                className="hidden"
                id="driver_license"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <label
                htmlFor="driver_license"
                className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
              >
                <DocumentTextIcon className="w-5 h-5 mr-2" />
                {files.driver_license ? files.driver_license.name : 'Select Driver License'}
              </label>
            </div>
            {files.driver_license && (
              <div className="mt-2">
                <span className="text-sm text-gray-600">{files.driver_license.name}</span>
                <button
                  type="button"
                  onClick={() => handleRemoveFile('driver_license')}
                  className="ml-2 text-red-500 hover:text-red-700"
                >
                  <XMarkIcon className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    )}
    
    {renderNavigationButtons()}
  </div>
);

// Add these functions inside the component, after renderUploadProofForm and before the if (loading) return
const canNavigateToStep = (stepNumber) => {
  // Allow navigation to step 1 always
  if (stepNumber === 1) return true;
  
  // Allow navigation to current step
  if (stepNumber === currentStep) return true;
  
  // Allow navigation to next step if current step is completed
  if (stepNumber === currentStep + 1 && completedSteps.includes(currentStep)) return true;
  
  // Allow navigation to any completed step
  if (completedSteps.includes(stepNumber)) return true;
  
  return false;
};

  const renderStepIndicator = () => (
  <div className="container-fluid">
    <ul className="list-none flex justify-between items-center my-8">
      {(steps || []).map((step, index) => {
        const stepNumber = index + 1;
        const isNavigable = canNavigateToStep(stepNumber);
        
        return (
          <li
            key={index}
            className={`relative flex-1 text-center ${
              currentStep === stepNumber 
                ? 'text-blue-600' 
                : isNavigable 
                  ? 'text-gray-700' 
                  : 'text-gray-400'
            }`}
            onClick={() => {
              if (isNavigable) {
                // console.log("Navigating to step:", stepNumber);
                setCurrentStep(stepNumber);
                setActiveTab(step.key);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }
            }}
            style={{ cursor: isNavigable ? 'pointer' : 'default' }}
          >
            <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center mb-2 border ${
              completedSteps.includes(stepNumber)
                ? 'bg-black text-white'
                : currentStep === stepNumber
                  ? 'border-blue-600 text-blue-600'
                  : isNavigable
                    ? 'border-gray-500'
                    : 'border-gray-300'
            }`}>
              {stepNumber}
            </div>
            <span className="hidden md:block">{step.name}</span>
          </li>
        );
      })}
    </ul>
  </div>
);

const renderCurrentStep = () => {
  switch (currentStep) {
    case 1:
      return renderAccountForm();
    case 2:
      return renderBeneficiaryForm();
    case 3:
      return renderPaymentDetailsForm();
    case 4:
      return renderESignatureForm();
    case 5:
      return renderUploadProofForm();
    default:
      return renderAccountForm();
  }
};

const getActiveRequest = async (userToken) => {
  try {
    const response = await get_active_trans_req_step(userToken, 1);
    // console.log("Active request response:", response);
    
    if (response.success === 200 && response.old_request === 1) {
      const req = response.trans_request;
      setReqDetails(req);
      
      if (req.req_records) {
        const records = JSON.parse(req.req_records);
        // console.log("Parsed records:", records);
        
        // Determine the subaccounts based on the selected account type
        const map_ac = {
          1: "cash",
          3: "securities",
          2: "property",
          4: "my-investment",
          5: "custodian",
          6: "commodities",
          7: "crypto"
        };
        
        const accountType = map_ac[records.account.ac_id];
        let subAccounts = [];
        
        switch (accountType) {
          case 'cash':
            subAccounts = cashAccounts;
            break;
          case 'property':
            subAccounts = property;
            break;
          case 'securities':
            subAccounts = securitiesAccounts;
            break;
          case 'my-investment':
            subAccounts = myInvestment;
            break;
          case 'custodian':
            subAccounts = custodian;
            break;
          case 'commodities':
            subAccounts = commodities;
            break;
          case 'crypto':
            subAccounts = crypto;
            break;
          default:
            subAccounts = [];
        }
        // console.log("sub account check",subAccounts)
        // Find the matching subaccount to get the reference code
        const matchingSubAccount = subAccounts.find(acc => acc.subac_id == records.account.cashac_id);
        const ac_ref_code = matchingSubAccount?.subac_reference_code || '';
        
        
        // Set form data with all necessary fields
        setFormData(prev => {
          const updatedData = {
            ...prev,
            // Account Information
            ac_id: records.account.ac_id || '',
            cashac_id: records.account.cashac_id || '',
            ac_ref_code: ac_ref_code,
            payment_reason: records.account.payment_reason || '',
            subAccounts: subAccounts || [],
            
            // Beneficiary Information
            beneficiary_type: records.beneficiary?.beneficiary_type || '',
            beneficiary_id: records.beneficiary?.beneficiary_id || '',
            bank_id: records.beneficiary?.bank_id || '',
            beneficiary_user_type: records.beneficiary?.beneficiary_user_type || '',
            beneficiary_name: records.beneficiary?.beneficiary_name || '',
            beneficiary_company_reg_no: records.beneficiary?.beneficiary_company_reg_no || '',
            beneficiary_nationality: records.beneficiary?.beneficiary_nationality || '',
            beneficiary_reg_country: records.beneficiary?.beneficiary_reg_country || '',
            beneficiary_structure: records.beneficiary?.beneficiary_structure || '',
            
            // Payment Details
            payment_amount: records.payment_details?.payment_amount || '',
            payment_currency: records.payment_details?.payment_currency || '',
            payment_type: records.payment_details?.payment_type || '',
            
            // Other fields from records
            ...records.account,
            ...records.beneficiary,
            ...records.payment_details
          };
          // console.log("Updated form data:", updatedData);
          return updatedData;
        });
        
        setRecords(records);
      }
      
      if (req.req_completed_steps) {
        const completedStepsArray = req.req_completed_steps.split(',').map(Number);
        setCompletedSteps(completedStepsArray);
      }
      
      setFinalStep(5);
      
      // Set current step
      setCurrentStep(req.req_current_step);
      setActiveTab(steps[req.req_current_step - 1]?.key || 'account');
    }
  } catch (error) {
    console.error('Error getting active request:', error);
  }
};

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
  <div className="min-h-screen bg-gray-50">
    <div className="max-w-7xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm">
        

        {renderStepIndicator()}

        <div className="p-6">
          {renderCurrentStep()}
        </div>
      </div>
    </div>
    <Toast ref={toastRef} />
    <BeneficiaryModal
      beneficiaryId={beneficiaryId}
      show={showBeneficiaryModal}
      onClose={() => setShowBeneficiaryModal(false)}
      className={`fixed inset-0 z-50 ${showBeneficiaryModal ? 'flex' : 'hidden'} items-center justify-center bg-black bg-opacity-50`}
    />
  </div>
);
};

export default Debit;
